import React, { useEffect, useState } from 'react';
import { setIsInTeams } from '@shared/store/auth.duck';
import { app } from "@microsoft/teams-js";
import { useDispatch } from "react-redux";
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import App from "./App";

export function TeamsCheckAppWrapper(props: Props) {
  const [waitingForTeamsCheck, setWaitingForTeamsCheck] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    app.initialize()
      .then(() => {
        dispatch(setIsInTeams(true));
        app.notifyAppLoaded();
        setTimeout(() => app.notifySuccess(), 50);
      })
      .catch(() => {
        // ignore
      })
      .finally(() => {
        setWaitingForTeamsCheck(false);
      });
  }, [dispatch]);

  if (waitingForTeamsCheck) {
    return <>
      <Center>
        <BodyRegular>Checking MS Teams</BodyRegular>
      </Center>
    </>;
  }

  return <App />
}

interface Props {
}
